export const GEOGRAPHY = 'Geography';
export const BUSINESSSEGMENT = 'Business Segment';
export const LEGALCONSTITUTION = 'Legal Constitution';
export const NICSEGMENT = 'Industry Segment (NIC)';
export const VENDOR = 'VENDOR';
export const SUPPLIER = 'SUPPLIER';
export const LOW = 'LOW';
export const MEDIUM = 'MEDIUM';
export const HIGH = 'HIGH';
export const UP = 'UP';
export const DOWN = 'DOWN';
export const STABLE = 'STABLE';
export const COMPLETE = 'COMPLETED';
export const PENDING = 'PENDING';
export const ALL = 'ALL';
export const INTERNATIONAL = 'INTERNATIONAL';
export const DOMESTIC = 'DOMESTIC';